export class HamburgerMenu {
    private body: HTMLElement | null;
    private hamburger: HTMLElement | null;
    private menu: HTMLElement | null;
    private menuListItems: NodeListOf<HTMLLIElement>;
    private navBack: NodeListOf<HTMLButtonElement>;
    private header: HTMLElement | null;
    private headerSubmenu: HTMLElement | null;
    private submenu: HTMLElement | null;

    constructor(hamburgerDataId: string, menuDataId: string) {
        this.body = document.body;
        this.hamburger = document.querySelector(`[data-jsid="${hamburgerDataId}"]`);
        this.menu = document.querySelector(`[data-jsid="${menuDataId}"]`);
        this.navBack = document.querySelectorAll(`[data-menu-back]`);
        const ul = this.menu?.querySelector('ul');
        //this.menuListItems = ul ? ul.querySelectorAll('li') : ([] as unknown as NodeListOf<HTMLLIElement>);
        this.menuListItems = ul ? ul.querySelectorAll(':scope > li') : ([] as unknown as NodeListOf<HTMLLIElement>);
        this.header = document.querySelector('header');
        this.headerSubmenu = document.querySelector('.header-submenu');
        this.submenu = document.querySelector('[data-submenu]');

        this.init();
    }

    private init(): void {
        this.hamburger?.addEventListener("click", () => this.handleClickToggleMenu());

        this.menuListItems.forEach((li) => {
            li.addEventListener('click', () => this.handleClickOpenSubNav(li));

            li.addEventListener('mouseenter', () => {
                const firstChild = li.firstElementChild;
                if (!(firstChild instanceof HTMLAnchorElement)) {
                    document.body.classList.add('hover');
                }
            });

            li.addEventListener('mouseleave', () => {
                document.body.classList.remove('hover');
            });
        });

        this.navBack.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.stopPropagation();
                this.handleClickNavBack(button);
            });
        });

        document.addEventListener('keydown', (event) => this.handleEscapeKey(event));
        window.addEventListener('scroll', () => this.handleScroll());
        this.handleScroll(); // run once on load

        if (this.header) {
            this.header.addEventListener('mouseenter', () => {
                this.body!.classList.add('header-hover');
            });
            this.header.addEventListener('mouseleave', () => {
                this.body!.classList.remove('header-hover');
            });
        }
    }

    private handleClickToggleMenu(): void {
        this.menu?.classList.toggle("open");
        this.body?.classList.toggle('header-hover');
        this.body?.classList.toggle("overflow-hidden");
    }

    private handleClickOpenSubNav(clickedItem: HTMLLIElement): void {
        this.menuListItems.forEach((li) => li.classList.remove('open'));
        clickedItem.classList.add('open');
        
        const parentUl = clickedItem.parentElement;
        if (parentUl instanceof HTMLUListElement) {
            parentUl.classList.add('open');
        }
    }

    private handleClickNavBack(button: HTMLButtonElement): void {
        this.menuListItems.forEach(li => {
            li.classList.remove('open');
            const parentUl = li.parentElement;
            if (parentUl instanceof HTMLUListElement) {
                parentUl.classList.remove('open');
            }
        });
    }

    private handleEscapeKey(event: KeyboardEvent): void {
        if (event.key === 'Escape' && this.menu?.classList.contains('open')) {
            this.body?.classList.remove("overflow-hidden");
            this.body?.classList.remove('header-hover');
            this.menu?.classList.remove('open');
            this.menuListItems.forEach(li => {
                li.classList.remove('open');
                const parentUl = li.parentElement;
                if (parentUl instanceof HTMLUListElement) {
                    parentUl.classList.remove('open');
                }
            });
        }
    }

    private handleScroll(): void {

        // optional: keep your original "scrolled" body class
        if (window.scrollY > 0) {
            this.body?.classList.add('scrolled');
        } else {
            this.body?.classList.remove('scrolled');
        }

        if (!this.header || !this.submenu) return;

        const submenuBottom = this.submenu.getBoundingClientRect().bottom;

        if (submenuBottom <= 0) {
            this.headerSubmenu.classList.add('is-sticky');
        } else {
            this.headerSubmenu.classList.remove('is-sticky');
        }
    }
}
